import { http, HttpResponse } from 'msw'

export const mockUpdateCustomerCard = http.put(
  '/my-business/api/agency/v1/customers/:customerId/cards/:cardId',
  () =>
    HttpResponse.json({ timestamp: new Date().toISOString() }, { status: 200 }),
)
